//
// formatChartDateRange;
//
// Take in a couple of JS date objects, output a date range depending on the chart precision
//
// input
//
// dateStart, dateEnd     The JS Date objects (beginning - end)
// displayPeriod          Chart precision, 'hours', 'days', 'weeks', 'months', 'years'
// locale                 A date-fns/locale object
//

import { format } from 'date-fns';

import {
  logError,
  stringUpperCaseFirstLetter,
} from '../../utils';

const formatChartDateRange = (dateStart, dateEnd, displayPeriod, locale) => {
  let ret;

  try {
    if (displayPeriod === 'years') {
      ret = `${format(dateStart, 'yyyy', { locale })} - ${format(dateEnd, 'yyyy', { locale })}`;
    } else if (displayPeriod === 'months') {
      ret = `${format(dateStart, 'MMM yy', { locale })} - ${format(dateEnd, 'MMM yy', { locale })}`;
    } else if (displayPeriod === 'weeks') {
      ret = `${format(dateStart, 'EEEE d MMM', { locale })} - ${
        format(dateEnd, 'd MMM yyyy', { locale })}`;
    } else if (displayPeriod === 'hours') {
      // Check if both dates are on the same day
      const isSameDay = dateStart.toDateString() === dateEnd.toDateString();

      if (isSameDay) {
        // Same day: "3 Jun 14:00 - 18:00"
        ret = `${format(dateStart, 'd MMM HH:mm', { locale })} - ${format(dateEnd, 'HH:mm', { locale })}`;
      } else {
        // Different days: "3 Jun 14:00 - 4 Jun 18:00"
        ret = `${format(dateStart, 'd MMM HH:mm', { locale })} - ${format(dateEnd, 'd MMM HH:mm', { locale })}`;
      }
    } else {
      // if (displayPeriod === 'days')
      ret = `${format(dateStart, 'd MMM', { locale })} - ${format(dateEnd, 'd MMM yyyy', { locale })}`;
    }
  } catch (err) {
    logError(
      `formatChartDateRange err=${err}`,
      'formatChartDateRange.formatError',
      {
        err: err?.message,
        displayPeriod,
        startTime: dateStart?.getTime?.(),
        endTime: dateEnd?.getTime?.(),
      },
    );
    throw new Error(`formatChartDateRange ${err}`, { cause: err });
  }

  return stringUpperCaseFirstLetter(ret);
};

export default formatChartDateRange;
